import { useMemo } from 'react';
import { useTransactionContextV2 } from '@/contexts/Transaction';
import { useWeb3Context } from '@/contexts/Web3Context';
import { isVaultV2ExitGated, isVaultV2Gated, type VaultV2Gates } from '@/helpers/vault';

/**
 * Hook that determines appropriate disabled label for vault V2 action button.
 * Loading is shown by the ActionButtons spinner, not a label.
 * Prioritizes messages: disabled deposits, active bundle, errors, empty input.
 * Any gate disables deposits; only an exit gate (`sendSharesGate`, `receiveAssetsGate`)
 * disables withdrawals.
 * @param params - Validation parameters
 * @returns Disabled label string or null if action enabled
 */
export function useVaultV2DisabledLabel(t0) {
  const {
    localErrorMessage,
    isInputEmpty,
    isListedVault,
    isDeposit,
    isCorrectVaultV2,
    gates,
    isTestVault,
    isDepositDisabled
  } = t0;
  const {
    account
  } = useWeb3Context();
  const {
    activeTransactions
  } = useTransactionContextV2();
  const isGated = isVaultV2Gated(gates);
  const isExitGated = isVaultV2ExitGated(gates);
  let t1;
  bb0: {
    if (isDeposit && isDepositDisabled) {
      t1 = "Deposits are disabled";
      break bb0;
    }
    if (isDeposit && (!isListedVault || isGated) && !isTestVault) {
      t1 = "Deposits are disabled";
      break bb0;
    }
    if (!isDeposit && isExitGated) {
      t1 = "Withdrawals are disabled";
      break bb0;
    }
    if (account.isWrongChain) {
      t1 = "Switch chain";
      break bb0;
    }
    if (activeTransactions) {
      t1 = "Another transaction is pending";
      break bb0;
    }
    if (!isCorrectVaultV2) {
      t1 = "Invalid vault";
      break bb0;
    }
    if (localErrorMessage) {
      t1 = localErrorMessage;
      break bb0;
    }
    if (isInputEmpty) {
      t1 = "Enter an amount";
      break bb0;
    }
    t1 = null;
  }
  return t1;
}